import { connect } from 'react-redux';
import { checkPin, setPin, setPinError, gotToRestorePinPage } from 'actions/parental-lock';
import { selectParentalPin, selectParentalError } from 'reducers/parental-lock/selectors';
import EnterPinModal from './EnterPinModal';

const mapStateToProps = (state) => {
  return {
    pin: selectParentalPin(state),
    error: selectParentalError(state),
  };
};

const mapDispatchToProps = { checkPin, setPin, setPinError, gotToRestorePinPage };

export default connect(mapStateToProps, mapDispatchToProps)(EnterPinModal);
